import Vue from 'vue';
import Boletos from './Boletos.vue';
import createStore from './store';

[...document.querySelectorAll('.vue-boletos')].forEach(el => {
    const store = createStore();
    let vm = new Vue({
        store,
        render: (h) =>
            h(Boletos, {
                props: {
                    empresa: el.getAttribute("empresa"),
                    banner: el.getAttribute("banner"),
                    banner_popup: el.getAttribute("banner_popup") || "",
                    recaptcha_key: el.getAttribute("recaptcha_key"),
                    popup_simulacao: el.getAttribute("popup_simulacao")|0,
                },
            }),
    });
    vm.$mount(el);
});

if (module.hot) {
    module.hot.accept();
}